import numeral from "numeral";
import moment from "moment";
// Locales, when imported, just sets up all the locales for moment.  It doesn't need to be called afterwards.
import locales from "numeral/locales"; // eslint-disable-line no-unused-vars

export default {
    install (Vue, options) {
        Vue.setLocale = function (locale) {
            moment.locale(locale);
            return numeral.locale(locale);
        };

        Vue.mixin({
            data: function () {
                return {
                    defaultLng: "en"
                };
            },
            computed: {
                // Number formatting for internationalization
                $nf () {
                    return (x, format) => {
                        return numeral(x).format(format ? format : "0,0.00");
                    };
                },

                // Currency formatting for internationalization
                $cf () {
                    return (x, format) => {
                        return numeral(x).format(format ? format : "$0,0.00");
                    };
                },

                // Date formatting for internationalization
                // TODO: Review the default format
                $df () {
                    return (x, format) => {
                        return moment(x).format(format ? format : "L");
                    };
                }
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/plugins/internationalization.js